import ListHarvestProcesses from "@/views/organization/projections/estimated_harvest/ListHarvestProcesses.vue";
import ShowHarvestProcess from "@/views/organization/projections/estimated_harvest/ShowHarvestProcess.vue";
import ShowHarvestProcessEstimatedHarvests from "@/components/views/organization/projections/estimated_harvest/show_process/EstimatedHarvests.vue";
import ShowHarvestProcessEstimatedContainers from "@/components/views/organization/projections/estimated_harvest/show_process/EstimatedContainers.vue"
import NewEstimatedHarvest from "@/views/organization/projections/estimated_harvest/NewEstimatedHarvest.vue";
import EditEstimatedHarvest from "@/views/organization/projections/estimated_harvest/EditEstimatedHarvest.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "org",
  role: "projections",
  permission: "estimated_harvest"
});

export default [
  {
    path: "/org/:organization_id/projections/estimated_harvest/list_harvest_processes",
    name: routeName(""),
    redirect: { name: routeName("list_harvest_processes") }
  },
  {
    path: "/org/:organization_id/projections/estimated_harvest/list_harvest_processes",
    name: routeName("list_harvest_processes"),
    component: ListHarvestProcesses,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/projections/estimated_harvest/show_harvest_process/:harvest_process_id",
    name: routeName("show_harvest_process"),
    redirect: { name: routeName("show_harvest_process_estimated_harvests") },
    component: ShowHarvestProcess,
    props: true,
    meta: META,
    children: [
      {
        path: "estimated_harvests",
        name: routeName("show_harvest_process_estimated_harvests"),
        component: ShowHarvestProcessEstimatedHarvests,
        props: true
      },
      {
        path: "estimated_containers",
        name: routeName("show_harvest_process_estimated_containers"),
        component: ShowHarvestProcessEstimatedContainers,
        props: true
      }
    ]
  },
  {
    path: "/org/:organization_id/projections/estimated_harvest/:harvest_process_id/new",
    name: routeName("new_estimated_harvest"),
    component: NewEstimatedHarvest,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/projections/estimated_harvest/:harvest_process_id/edit/:estimated_harvest_id",
    name: routeName("edit_estimated_harvest"),
    component: EditEstimatedHarvest,
    props: true,
    meta: META
  }
];
